import { lazy } from "react";

export const PrivateAppLazy = lazy(() => import("./PrivateApp"));
